
export default {
  name: 'BaseSubscriptionWidgetStream',
  props: {
    stream: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isUserSubscribe() {
      if (this.$auth.loggedIn) {
        return this.$auth.user?.subscriptions?.streams?.find((subscription) => {
          return subscription.stream === this.stream?.id
        })
      }
      return false
    },
    userName() {
      if (this.$auth.user?.type === 'COMPANY') {
        return this.$auth.user?.company?.title
          ? this.$auth.user?.company?.title
          : this.$auth.user?.username
      } else {
        return this.$auth.user?.profile?.firstName
          ? `${this.$auth.user?.profile?.firstName}`
          : this.$auth.user?.username
      }
    },
  },
}
